import type { VoidFunctionComponent } from 'react';

import { DISABLE_ADD_PROJECT_BUTTON } from '../../../../../shared/featureFlags/flagNames';
import { isFeatureEnabled } from '../../../../helpers/features/featureFlags';
import NavigationButton from '../../../generic/Button/NavigationButton';
import TooltipButton from '../../../generic/Button/TooltipButton';
import { icons } from '../../../generic/Icon/icons';
import Link from '../../../generic/Link/Link';

import styles from './AddProjectsCTA.module.less';

const FOSSA_CLI_URL = 'https://github.com/fossas/fossa-cli?tab=readme-ov-file#getting-started';

const AddProjectsCTA: VoidFunctionComponent = () => {
  const isAddProjectButtonDisabled = isFeatureEnabled(DISABLE_ADD_PROJECT_BUTTON);

  return (
    <div className={styles.addProjectsCTA}>
      <div className={styles.message}>
        There aren&apos;t any projects here!
        {isAddProjectButtonDisabled ? (
          <> Use the <Link to={FOSSA_CLI_URL} openInNewTab>FOSSA CLI</Link> to add projects.</>
        ) : (
          ' Get started by importing some with the button below:'
        )}
      </div>
      {isAddProjectButtonDisabled ? (
        <TooltipButton
          id="projects-disabled-add-button"
          size="medium"
          icon={icons.plus}
          isDisabled
          showTooltip
          tooltip="Disabled by your admins"
          onClick={() => {}}
        >
          Add Projects
        </TooltipButton>
      ) : (
        <NavigationButton to="/projects/import" size="medium" icon={icons.plus}>
          Add Projects
        </NavigationButton>
      )}
    </div>
  );
};

export default AddProjectsCTA;
